import React from 'react';
import { Record } from 'immutable';

// Types
import { MeetingItem } from 'Shared/types/MeetingItem.type';

// Helpers
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Components
import MeetingItemHistoryItem from './MeetingItemHistoryItem';

// Styles
import './MeetingItemHistoryList.scss';

type Props = {
  meetingItem: Record<MeetingItem>;
  className?: string;
};

const MeetingItemHistoryList = ({ meetingItem, className }: Props) => {
  const history = MeetingItemHelpers.getHistory(meetingItem);
  const sortedList = history
    .sortBy(item => item.get('timestamp'))
    .reverse()
    .toJS();
  return (
    <div className={`MeetingItemHistoryList ${className}`}>
      {sortedList.map(item => (
        <MeetingItemHistoryItem key={`${item.timestamp}-${item.changeType || item.change_type}`} item={item} />
      ))}
    </div>
  );
};

export default MeetingItemHistoryList;
